module.exports = __webpack_public_path__ + "static/img/career-course-image1.f4358de7.png";